import React, { FunctionComponent } from 'react';
import { twMerge } from 'tailwind-merge';
import { v4 as uuidV4 } from 'uuid';
import { CheckboxProps } from './types';
import { Label } from '../Label';
import { Loadable } from '@/components/loaders';

type TInputType = CheckboxProps & React.ComponentProps<'input'>;

export const Checkbox: FunctionComponent<TInputType> = ({
  id,
  label,
  classNames,
  error,
  extraInfo,
  description,
  loading,
  forceShowingDescription,
  ...rest
}) => {
  if (!id) {
    id = uuidV4();
  }

  return (
    <div className={twMerge('flex items-start gap-2', classNames?.wrapper)}>
      <input
        {...rest}
        id={id}
        type='checkbox'
        disabled={loading || rest.disabled}
        className={twMerge(
          'text-brand-600 translate-y-[2.5px] focus:ring-brand-500 size-4 border-quaternary-300 rounded disabled:bg-brand-100 disabled:text-brand-400',
          error && 'border-red-500 hover:border-red-500 focus:border-red-500 outline-none',
          classNames?.checkbox
        )}
      />
      <Loadable className='h-5 justify-start' spinnerClassName='size-3' isLoading={loading}>
        <div>
          {(label || description) && (
            <>
              <Label className={twMerge('p-0 text-quaternary-700 cursor-pointer', classNames?.label)} htmlFor={id} isRequired={rest.required}>
                {label}
              </Label>
              <p
                id='checkbox-description'
                className={twMerge('text-sm font-normal text-quaternary-500', forceShowingDescription && !description ? 'h-6' : '', classNames?.description)}
              >
                {description}
              </p>
            </>
          )}
          {extraInfo && <p className={twMerge('text-sm text-quaternary-800', classNames?.extraInfo)}>{extraInfo}</p>}
          {error && <p className={twMerge('text-sm text-red-600', classNames?.errorText)}>{error}</p>}
        </div>
      </Loadable>
    </div>
  );
};
